import { useAuth, useAutoSignin } from 'react-oidc-context';
import './App.css';
import { CircularProgress, CssBaseline, Typography } from '@mui/material';
import { createRootRoute, createRoute, createRouter, RouterProvider } from '@tanstack/react-router';
import MainLayout from './components/main/MainLayout';
import NotFound from './components/main/NotFound';
import TemplatesLayout from './components/templates/TemplatesLayout';
import { ColumnDirectionJustifyCenterAlignCenterFlexFill, RowJustifyStartFlex } from './components/commons/Containers';

export const AuthContext = {};

function App() {

  const auth = useAuth();
  AuthContext['authorization'] = auth;
  const { isLoading, isAuthenticated, error } = useAutoSignin();

  const rootRoute = createRootRoute({
    component: () => <MainLayout />,
    notFoundComponent: () => <NotFound />
  });

  const rootIndex = createRoute({
    getParentRoute: () => rootRoute,
    path: '/'
  });

  const templatesRoute = createRoute({
    getParentRoute: () => rootIndex,
    component: () => <TemplatesLayout />,
    path: 'templates'
  });

  const routeTree = rootRoute.addChildren([rootIndex.addChildren([templatesRoute])]);
  const router = createRouter({ routeTree });


  return (
    <>
      <CssBaseline />
      {isLoading && <ColumnDirectionJustifyCenterAlignCenterFlexFill>
        <RowJustifyStartFlex gap={1}>
          <CircularProgress />
          <Typography>
            Logging in...
          </Typography>
        </RowJustifyStartFlex>
      </ColumnDirectionJustifyCenterAlignCenterFlexFill>}
      {isAuthenticated && <RouterProvider router={router} />}
      {error && <ColumnDirectionJustifyCenterAlignCenterFlexFill>
        <Typography>
          Error while logging in, please contact system administrator..
        </Typography>
      </ColumnDirectionJustifyCenterAlignCenterFlexFill>}
    </>
  );
}

export default App;
